import React from "react";

import { AccountLink, AccountLinksWrapper } from "./styled";

/**
 * Privary/Accessibility Links for Account page dialog
 */
const AccountLinks = () =>
  <AccountLinksWrapper>
    <AccountLink
      href="//www.workplace-violence.ca/privacy-policy/"
      target="_blank"
    >
      Privacy Policy
    </AccountLink>
    <AccountLink
      href="//www.pshsa.ca/about-us/accessibility/"
      target="_blank"
    >
      Accessibility
    </AccountLink>
    <AccountLink
      href="//www.pshsa.ca/wp-content/uploads/2017/08/Assessing_Violence_in_the_Community_Online_User_Guide_V1.0_VDVTLAEN0817.pdf"
      target="_blank"
    >
      User Guide
    </AccountLink>
  </AccountLinksWrapper>;

export default AccountLinks;



// WEBPACK FOOTER //
// ./src/common/components/AccountLinks/index.jsx